// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* GitHub Projects (v2) table view — light theme */
.gh-projects {
  --ghp-bg: #ffffff;
  --ghp-surface: #ffffff;
  --ghp-surface-1: #f6f8fa;
  --ghp-surface-2: #eaeef2;
  --ghp-border: #d0d7de;
  --ghp-border-muted: #d8dee4;
  --ghp-text: #1f2328;
  --ghp-text-muted: #59636e;
  --ghp-link: #0969da;
  --ghp-open: #1a7f37;
  --ghp-closed: #8250df;
  --ghp-accent: #0969da;
  background: var(--ghp-bg);
  color: var(--ghp-text);
  border-radius: 6px;
  border: 1px solid var(--ghp-border);
  font-size: 13px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif;
}
.gh-projects__header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px 8px;
  border-bottom: 1px solid var(--ghp-border);
}
.gh-projects__header .ghp-title {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--ghp-text);
  font-size: 16px;
  font-weight: 600;
}
.gh-projects__tabs {
  display: flex;
  align-items: stretch;
  gap: 0;
  padding: 0 8px;
  border-bottom: 1px solid var(--ghp-border);
  overflow-x: auto;
  background: var(--ghp-bg);
}
.gh-projects__tabs::-webkit-scrollbar {
  height: 6px;
}
.gh-projects__tabs::-webkit-scrollbar-thumb {
  background: var(--ghp-border);
  border-radius: 3px;
}
.gh-projects__tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  color: var(--ghp-text-muted);
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  white-space: nowrap;
  font-size: 13px;
}
.gh-projects__tab:hover {
  color: var(--ghp-text);
  background: var(--ghp-surface-1);
}
.gh-projects__tab.is-active {
  color: var(--ghp-text);
  font-weight: 600;
  border-bottom-color: var(--ghp-accent);
  background: #ddf4ff;
}
.gh-projects__tab .tab-icon {
  color: currentColor;
  display: inline-flex;
}
.gh-projects__tab .tab-caret {
  opacity: 0.7;
}
.gh-projects__tab-wrap {
  display: inline-flex;
  align-items: stretch;
}
.gh-projects__tab-menu {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
  margin-left: -4px;
  border: none;
  background: transparent;
  color: var(--ghp-text-muted);
  cursor: pointer;
  border-bottom: 2px solid var(--ghp-accent);
}
.gh-projects__tab-menu:hover {
  color: var(--ghp-text);
  background: var(--ghp-surface-1);
}
.gh-projects__newview {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 8px 12px;
  color: var(--ghp-text-muted);
  background: transparent;
  border: none;
  cursor: pointer;
  white-space: nowrap;
}
.gh-projects__newview:hover {
  color: var(--ghp-text);
}
.gh-projects__searchrow {
  padding: 8px 12px;
  border-bottom: 1px solid var(--ghp-border);
  background: var(--ghp-bg);
}
.gh-projects__searchrow .ant-input-affix-wrapper {
  background: var(--ghp-surface-1);
  border: 1px solid var(--ghp-border);
  border-radius: 6px;
  color: var(--ghp-text);
  height: 32px;
}
.gh-projects__searchrow .ant-input-affix-wrapper:hover, .gh-projects__searchrow .ant-input-affix-wrapper:focus-within {
  background: #ffffff;
  border-color: var(--ghp-accent);
  box-shadow: 0 0 0 3px rgba(9, 105, 218, 0.2);
}
.gh-projects__searchrow .ant-input-affix-wrapper .ant-input-prefix {
  color: var(--ghp-text-muted);
  margin-right: 8px;
}
.gh-projects__searchrow .ant-input-affix-wrapper input.ant-input {
  background: transparent;
  color: var(--ghp-text);
  font-size: 13px;
}
.gh-projects__searchrow .ant-input-affix-wrapper input.ant-input::placeholder {
  color: var(--ghp-text-muted);
}
.gh-projects__tablewrap {
  overflow-x: auto;
  background: var(--ghp-bg);
}
.gh-projects__table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 13px;
  color: var(--ghp-text);
}
.gh-projects__table thead th {
  position: sticky;
  top: 0;
  background: var(--ghp-bg);
  color: var(--ghp-text-muted);
  font-weight: 600;
  text-align: left;
  padding: 8px 12px;
  border-bottom: 1px solid var(--ghp-border);
  white-space: nowrap;
  -webkit-user-select: none;
          user-select: none;
}
.gh-projects__table thead th .ghp-colhead {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 8px;
}
.gh-projects__table thead th .ghp-colhead .ghp-colmore {
  opacity: 0;
  color: var(--ghp-text-muted);
  padding: 2px 4px;
  border-radius: 4px;
  cursor: pointer;
}
.gh-projects__table thead th .ghp-colhead .ghp-colmore:hover {
  background: var(--ghp-surface-2);
  color: var(--ghp-text);
}
.gh-projects__table thead th:hover .ghp-colmore {
  opacity: 1;
}
.gh-projects__table thead th.ghp-col-code {
  width: 170px;
  min-width: 150px;
  color: var(--ghp-text-muted);
}
.gh-projects__table tbody tr:hover td {
  background: var(--ghp-surface-1);
}
.gh-projects__table tbody td {
  padding: 8px 12px;
  border-bottom: 1px solid var(--ghp-border-muted);
  vertical-align: middle;
  background: transparent;
}
.gh-projects__table tbody td.ghp-col-code {
  color: var(--ghp-text-muted);
  width: 170px;
  white-space: nowrap;
}
.gh-projects__table tbody td.ghp-col-code .ghp-code {
  font-family: ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, "Liberation Mono", monospace;
  font-size: 12px;
}
.gh-projects .ghp-title-cell {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  max-width: 100%;
}
.gh-projects .ghp-title-cell .ghp-status-icon {
  flex: 0 0 auto;
}
.gh-projects .ghp-title-cell .ghp-status-icon.is-open {
  color: var(--ghp-open);
}
.gh-projects .ghp-title-cell .ghp-status-icon.is-closed {
  color: var(--ghp-closed);
}
.gh-projects .ghp-title-cell .ghp-title-text {
  color: var(--ghp-text);
  font-weight: 500;
  cursor: pointer;
  overflow-wrap: anywhere;
  word-break: break-word;
  min-width: 400px;
  max-width: 400px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.gh-projects .ghp-title-cell .ghp-title-text:hover {
  color: var(--ghp-link);
  text-decoration: underline;
}
.gh-projects .ghp-title-cell .ghp-hashcode {
  color: var(--ghp-text-muted);
  font-size: 12px;
  flex: 0 0 auto;
}
.gh-projects .ghp-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 10px;
  border-radius: 2em;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  border: 1px solid transparent;
  white-space: nowrap;
  max-width: 100%;
}
.gh-projects .ghp-pill.is-lock {
  padding-left: 6px;
}
.gh-projects .ghp-pill .pill-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
}
.gh-projects .ghp-pill-cell {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  max-width: 100%;
}
.gh-projects .ghp-pill-cell .ghp-cell-caret {
  color: var(--ghp-text-muted);
  opacity: 0;
  transition: opacity 0.1s;
}
.gh-projects tbody tr:hover .ghp-cell-caret {
  opacity: 1;
}
.gh-projects .ghp-empty-cell {
  color: var(--ghp-text-muted);
  font-size: 12px;
}
.gh-projects .ghp-assignees {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.gh-projects .ghp-assignees .ant-avatar {
  border: 2px solid var(--ghp-bg);
}
.gh-projects .ghp-assignees .ghp-assignee-name {
  color: var(--ghp-text);
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 120px;
}
.gh-projects .ghp-labels-cell {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 4px;
  max-width: 260px;
}
.gh-projects__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 12px;
  border-top: 1px solid var(--ghp-border);
  background: var(--ghp-bg);
  color: var(--ghp-text-muted);
  font-size: 12px;
}
.gh-projects__footer .ant-pagination-item,
.gh-projects__footer .ant-pagination-prev,
.gh-projects__footer .ant-pagination-next,
.gh-projects__footer .ant-pagination-jump-prev,
.gh-projects__footer .ant-pagination-jump-next {
  background: transparent;
  border-color: var(--ghp-border);
}
.gh-projects__footer .ant-pagination-item a,
.gh-projects__footer .ant-pagination-prev a,
.gh-projects__footer .ant-pagination-next a,
.gh-projects__footer .ant-pagination-jump-prev a,
.gh-projects__footer .ant-pagination-jump-next a {
  color: var(--ghp-text);
}
.gh-projects__footer .ant-pagination-item-active {
  background: var(--ghp-accent);
  border-color: var(--ghp-accent);
}
.gh-projects__footer .ant-pagination-item-active a {
  color: #fff;
}
.gh-projects__empty {
  padding: 56px 24px;
  text-align: center;
  color: var(--ghp-text-muted);
}
.gh-projects .ghp-title-edit {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  width: 100%;
}
.gh-projects .ghp-title-edit input {
  flex: 1 1;
  padding: 4px 8px;
  border: 1px solid var(--ghp-border);
  border-radius: 4px;
  font-size: 13px;
  color: var(--ghp-text);
  background: #fff;
}
.gh-projects .ghp-title-edit input:focus {
  outline: none;
  border-color: var(--ghp-link);
  box-shadow: 0 0 0 3px rgba(9, 105, 218, 0.2);
}
.gh-projects .ghp-title-pencil {
  opacity: 0;
  cursor: pointer;
  color: var(--ghp-text-muted);
  padding: 2px 4px;
  border-radius: 3px;
  display: inline-flex;
}
.gh-projects .ghp-title-pencil:hover {
  background: var(--ghp-surface-2);
  color: var(--ghp-text);
}
.gh-projects tbody tr:hover .ghp-title-pencil {
  opacity: 1;
}
.gh-projects .ghp-pill-cell {
  cursor: pointer;
}
.gh-projects .ghp-date-cell {
  cursor: pointer;
}
.gh-projects .ghp-date-cell:hover {
  color: var(--ghp-link);
}

.ghp-autocomplete {
  position: absolute;
  top: 100%;
  left: 12px;
  right: 12px;
  margin-top: 4px;
  z-index: 20;
  background: #fff;
  border: 1px solid #d0d7de;
  border-radius: 6px;
  box-shadow: 0 8px 24px rgba(140, 149, 159, 0.2);
  max-height: 280px;
  overflow-y: auto;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif;
}
.ghp-autocomplete__item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 12px;
  cursor: pointer;
  font-size: 13px;
  color: #1f2328;
  border-bottom: 1px solid #f6f8fa;
}
.ghp-autocomplete__item:last-child {
  border-bottom: none;
}
.ghp-autocomplete__item:hover, .ghp-autocomplete__item.is-active {
  background: #f6f8fa;
}
.ghp-autocomplete__item .ghp-ac-kind {
  font-size: 11px;
  text-transform: uppercase;
  color: #59636e;
  background: #eaeef2;
  border-radius: 3px;
  padding: 1px 6px;
  min-width: 56px;
  text-align: center;
}
.ghp-autocomplete__item.is-any .ghp-ac-kind {
  background: #ddf4ff;
  color: #0969da;
}
.ghp-autocomplete__item.is-no .ghp-ac-kind {
  background: #fff8c5;
  color: #9a6700;
}
.ghp-autocomplete__item .ghp-ac-label {
  flex: 1 1;
}

.ghp-popover {
  background: #ffffff;
  border: 1px solid #d0d7de;
  border-radius: 6px;
  box-shadow: 0 8px 24px rgba(140, 149, 159, 0.2);
  min-width: 260px;
  max-width: 360px;
  overflow: hidden;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif;
}
.ghp-popover__head {
  padding: 8px 12px;
  border-bottom: 1px solid #d8dee4;
  font-size: 12px;
  color: #59636e;
  font-weight: 600;
}
.ghp-popover__search {
  padding: 8px 12px;
  border-bottom: 1px solid #d8dee4;
}
.ghp-popover__search input {
  width: 100%;
  padding: 5px 8px;
  border: 1px solid #d0d7de;
  border-radius: 6px;
  font-size: 13px;
  background: #f6f8fa;
}
.ghp-popover__search input:focus {
  outline: none;
  border-color: #0969da;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(9, 105, 218, 0.2);
}
.ghp-popover__list {
  max-height: 280px;
  overflow-y: auto;
}
.ghp-popover__item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  cursor: pointer;
  font-size: 13px;
  color: #1f2328;
  border-bottom: 1px solid #f6f8fa;
}
.ghp-popover__item:hover {
  background: #f6f8fa;
}
.ghp-popover__item.is-active {
  background: #ddf4ff;
}
.ghp-popover__item:last-child {
  border-bottom: none;
}
.ghp-popover__item .ghp-check {
  width: 16px;
  flex: 0 0 auto;
  color: #1f2328;
  visibility: hidden;
}
.ghp-popover__item.is-selected .ghp-check {
  visibility: visible;
}
.ghp-popover__item .ghp-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex: 0 0 auto;
}
.ghp-popover__item .ghp-item-label {
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ghp-popover__empty {
  padding: 16px;
  text-align: center;
  color: #59636e;
  font-size: 12px;
}
.ghp-popover__foot {
  padding: 6px 12px;
  border-top: 1px solid #d8dee4;
  background: #f6f8fa;
  display: flex;
  gap: 8px;
  justify-content: space-between;
}
.ghp-popover__foot button {
  padding: 2px 8px;
  border: 1px solid #d0d7de;
  background: #fff;
  color: #1f2328;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
}
.ghp-popover__foot button:hover {
  background: #f6f8fa;
}
.ghp-popover__foot button.is-danger {
  color: #cf222e;
}`, "",{"version":3,"sources":["webpack://./src/components/ProjectBoard/IssuesListView.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,kDAAA;AACA;EACE,iBAAA;EACA,sBAAA;EACA,wBAAA;EACA,wBAAA;EACA,qBAAA;EACA,2BAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;EACA,qBAAA;EAEA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mCAAA;EACA,eAAA;EACA,wFAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,sBAAA;EACA,0CAAA;AACJ;AACI;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;AACN;AAGE;EACE,aAAA;EACA,oBAAA;EACA,MAAA;EACA,cAAA;EACA,0CAAA;EACA,gBAAA;EACA,yBAAA;AADJ;AAGI;EAAuB,WAAA;AAA3B;AACI;EAA6B,6BAAA;EAA+B,kBAAA;AAGhE;AAAE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,4BAAA;EACA,uBAAA;EACA,YAAA;EACA,oCAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;AAEJ;AAAI;EACE,sBAAA;EACA,gCAAA;AAEN;AACI;EACE,sBAAA;EACA,gBAAA;EACA,sCAAA;EACA,mBAAA;AACN;AAEI;EACE,mBAAA;EACA,oBAAA;AAAN;AAGI;EACE,YAAA;AADN;AAKE;EACE,oBAAA;EACA,oBAAA;AAHJ;AAME;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;EACA,uBAAA;EACA,4BAAA;EACA,eAAA;EACA,0CAAA;AAJJ;AAMI;EAAU,sBAAA;EAAwB,gCAAA;AAFtC;AAKE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,4BAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;AAHJ;AAKI;EAAU,sBAAA;AAFd;AAKE;EACE,iBAAA;EACA,0CAAA;EACA,yBAAA;AAHJ;AAKI;EACE,gCAAA;EACA,mCAAA;EACA,kBAAA;EACA,sBAAA;EACA,YAAA;AAHN;AAKM;EACE,mBAAA;EACA,+BAAA;EACA,4CAAA;AAHR;AAMM;EACE,4BAAA;EACA,iBAAA;AAJR;AAOM;EACE,uBAAA;EACA,sBAAA;EACA,eAAA;AALR;AAOQ;EACE,4BAAA;AALV;AAWE;EACE,gBAAA;EACA,yBAAA;AATJ;AAYE;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;EACA,sBAAA;AAVJ;AAYI;EACE,gBAAA;EACA,MAAA;EACA,yBAAA;EACA,4BAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,0CAAA;EACA,mBAAA;EACA,yBAAA;UAAA,iBAAA;AAVN;AAYM;EACE,oBAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,QAAA;AAVR;AAYQ;EACE,UAAA;EACA,4BAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AAVV;AAYU;EAAU,gCAAA;EAAkC,sBAAA;AARtD;AAYM;EAAuB,UAAA;AAT7B;AAWM;EACE,YAAA;EACA,gBAAA;EACA,4BAAA;AATR;AAcM;EACE,gCAAA;AAZR;AAgBI;EACE,iBAAA;EACA,gDAAA;EACA,sBAAA;EACA,uBAAA;AAdN;AAgBM;EACE,4BAAA;EACA,YAAA;EACA,mBAAA;AAdR;AAgBQ;EACE,mGAAA;EACA,eAAA;AAdV;AAoBE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAlBJ;AAoBI;EACE,cAAA;AAlBN;AAoBM;EAAY,sBAAA;AAjBlB;AAkBM;EAAc,wBAAA;AAfpB;AAkBI;EACE,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AAhBN;AAkBM;EAAU,sBAAA;EAAwB,0BAAA;AAdxC;AAiBI;EACE,4BAAA;EACA,eAAA;EACA,cAAA;AAfN;AAmBE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;EACA,mBAAA;EACA,eAAA;AAjBJ;AAmBI;EACE,iBAAA;AAjBN;AAoBI;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;AAlBN;AAsBE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AApBJ;AAsBI;EACE,4BAAA;EACA,UAAA;EACA,wBAAA;AApBN;AAwBE;EAAiC,UAAA;AArBnC;AAuBE;EACE,4BAAA;EACA,eAAA;AArBJ;AAwBE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AAtBJ;AAwBI;EACE,+BAAA;AAtBN;AAyBI;EACE,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AAvBN;AA2BE;EACE,oBAAA;EACA,eAAA;EACA,QAAA;EACA,gBAAA;AAzBJ;AA4BE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,iBAAA;EACA,uCAAA;EACA,yBAAA;EACA,4BAAA;EACA,eAAA;AA1BJ;AA4BI;;;;;EAKE,uBAAA;EACA,+BAAA;AA1BN;AA2BM;;;;;EAAI,sBAAA;AApBV;AAuBI;EACE,6BAAA;EACA,+BAAA;AArBN;AAsBM;EAAI,WAAA;AAnBV;AAuBE;EACE,kBAAA;EACA,kBAAA;EACA,4BAAA;AArBJ;AAwBE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;AAtBJ;AAwBI;EACE,SAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;AAtBN;AAwBM;EACE,aAAA;EACA,6BAAA;EACA,4CAAA;AAtBR;AA2BE;EACE,UAAA;EACA,eAAA;EACA,4BAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;AAzBJ;AA2BI;EAAU,gCAAA;EAAkC,sBAAA;AAvBhD;AA0BE;EAAmC,UAAA;AAvBrC;AAyBE;EACE,eAAA;AAvBJ;AA0BE;EACE,eAAA;AAxBJ;AA0BI;EAAU,sBAAA;AAvBd;;AA2BA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,+CAAA;EACA,iBAAA;EACA,gBAAA;EACA,wFAAA;AAxBF;AA0BE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,gCAAA;AAxBJ;AA0BI;EAAe,mBAAA;AAvBnB;AAwBI;EAAuB,mBAAA;AArB3B;AAuBI;EACE,eAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AArBN;AAwBI;EAAwB,mBAAA;EAAqB,cAAA;AApBjD;AAqBI;EAAwB,mBAAA;EAAqB,cAAA;AAjBjD;AAmBI;EAAgB,SAAA;AAhBpB;;AAoBA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,+CAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,wFAAA;AAjBF;AAmBE;EACE,iBAAA;EACA,gCAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAjBJ;AAoBE;EACE,iBAAA;EACA,gCAAA;AAlBJ;AAoBI;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;AAlBN;AAoBM;EACE,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,4CAAA;AAlBR;AAuBE;EACE,iBAAA;EACA,gBAAA;AArBJ;AAwBE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,gCAAA;AAtBJ;AAwBI;EAAU,mBAAA;AArBd;AAsBI;EAAc,mBAAA;AAnBlB;AAoBI;EAAe,mBAAA;AAjBnB;AAmBI;EACE,WAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;AAjBN;AAoBI;EAA2B,mBAAA;AAjB/B;AAmBI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AAjBN;AAoBI;EACE,SAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAlBN;AAsBE;EACE,aAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AApBJ;AAuBE;EACE,iBAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,QAAA;EACA,8BAAA;AArBJ;AAuBI;EACE,gBAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AArBN;AAuBM;EAAU,mBAAA;AApBhB;AAqBM;EAAc,cAAA;AAlBpB","sourcesContent":["/* GitHub Projects (v2) table view — light theme */\n.gh-projects {\n  --ghp-bg: #ffffff;\n  --ghp-surface: #ffffff;\n  --ghp-surface-1: #f6f8fa;\n  --ghp-surface-2: #eaeef2;\n  --ghp-border: #d0d7de;\n  --ghp-border-muted: #d8dee4;\n  --ghp-text: #1f2328;\n  --ghp-text-muted: #59636e;\n  --ghp-link: #0969da;\n  --ghp-open: #1a7f37;\n  --ghp-closed: #8250df;\n  --ghp-accent: #0969da;\n\n  background: var(--ghp-bg);\n  color: var(--ghp-text);\n  border-radius: 6px;\n  border: 1px solid var(--ghp-border);\n  font-size: 13px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif;\n\n  &__header {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 12px 16px 8px;\n    border-bottom: 1px solid var(--ghp-border);\n\n    .ghp-title {\n      display: inline-flex;\n      align-items: center;\n      gap: 6px;\n      color: var(--ghp-text);\n      font-size: 16px;\n      font-weight: 600;\n    }\n  }\n\n  &__tabs {\n    display: flex;\n    align-items: stretch;\n    gap: 0;\n    padding: 0 8px;\n    border-bottom: 1px solid var(--ghp-border);\n    overflow-x: auto;\n    background: var(--ghp-bg);\n\n    &::-webkit-scrollbar { height: 6px; }\n    &::-webkit-scrollbar-thumb { background: var(--ghp-border); border-radius: 3px; }\n  }\n\n  &__tab {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 8px 12px;\n    color: var(--ghp-text-muted);\n    background: transparent;\n    border: none;\n    border-bottom: 2px solid transparent;\n    cursor: pointer;\n    white-space: nowrap;\n    font-size: 13px;\n\n    &:hover {\n      color: var(--ghp-text);\n      background: var(--ghp-surface-1);\n    }\n\n    &.is-active {\n      color: var(--ghp-text);\n      font-weight: 600;\n      border-bottom-color: var(--ghp-accent);\n      background: #ddf4ff;\n    }\n\n    .tab-icon {\n      color: currentColor;\n      display: inline-flex;\n    }\n\n    .tab-caret {\n      opacity: 0.7;\n    }\n  }\n\n  &__tab-wrap {\n    display: inline-flex;\n    align-items: stretch;\n  }\n\n  &__tab-menu {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0 6px;\n    margin-left: -4px;\n    border: none;\n    background: transparent;\n    color: var(--ghp-text-muted);\n    cursor: pointer;\n    border-bottom: 2px solid var(--ghp-accent);\n\n    &:hover { color: var(--ghp-text); background: var(--ghp-surface-1); }\n  }\n\n  &__newview {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    padding: 8px 12px;\n    color: var(--ghp-text-muted);\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    white-space: nowrap;\n\n    &:hover { color: var(--ghp-text); }\n  }\n\n  &__searchrow {\n    padding: 8px 12px;\n    border-bottom: 1px solid var(--ghp-border);\n    background: var(--ghp-bg);\n\n    .ant-input-affix-wrapper {\n      background: var(--ghp-surface-1);\n      border: 1px solid var(--ghp-border);\n      border-radius: 6px;\n      color: var(--ghp-text);\n      height: 32px;\n\n      &:hover, &:focus-within {\n        background: #ffffff;\n        border-color: var(--ghp-accent);\n        box-shadow: 0 0 0 3px rgba(9,105,218,0.2);\n      }\n\n      .ant-input-prefix {\n        color: var(--ghp-text-muted);\n        margin-right: 8px;\n      }\n\n      input.ant-input {\n        background: transparent;\n        color: var(--ghp-text);\n        font-size: 13px;\n\n        &::placeholder {\n          color: var(--ghp-text-muted);\n        }\n      }\n    }\n  }\n\n  &__tablewrap {\n    overflow-x: auto;\n    background: var(--ghp-bg);\n  }\n\n  &__table {\n    width: 100%;\n    border-collapse: separate;\n    border-spacing: 0;\n    font-size: 13px;\n    color: var(--ghp-text);\n\n    thead th {\n      position: sticky;\n      top: 0;\n      background: var(--ghp-bg);\n      color: var(--ghp-text-muted);\n      font-weight: 600;\n      text-align: left;\n      padding: 8px 12px;\n      border-bottom: 1px solid var(--ghp-border);\n      white-space: nowrap;\n      user-select: none;\n\n      .ghp-colhead {\n        display: inline-flex;\n        align-items: center;\n        justify-content: space-between;\n        width: 100%;\n        gap: 8px;\n\n        .ghp-colmore {\n          opacity: 0;\n          color: var(--ghp-text-muted);\n          padding: 2px 4px;\n          border-radius: 4px;\n          cursor: pointer;\n\n          &:hover { background: var(--ghp-surface-2); color: var(--ghp-text); }\n        }\n      }\n\n      &:hover .ghp-colmore { opacity: 1; }\n\n      &.ghp-col-code {\n        width: 170px;\n        min-width: 150px;\n        color: var(--ghp-text-muted);\n      }\n    }\n\n    tbody tr {\n      &:hover td {\n        background: var(--ghp-surface-1);\n      }\n    }\n\n    tbody td {\n      padding: 8px 12px;\n      border-bottom: 1px solid var(--ghp-border-muted);\n      vertical-align: middle;\n      background: transparent;\n\n      &.ghp-col-code {\n        color: var(--ghp-text-muted);\n        width: 170px;\n        white-space: nowrap;\n\n        .ghp-code {\n          font-family: ui-monospace, SFMono-Regular, 'SF Mono', Menlo, Consolas, 'Liberation Mono', monospace;\n          font-size: 12px;\n        }\n      }\n    }\n  }\n\n  .ghp-title-cell {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    max-width: 100%;\n\n    .ghp-status-icon {\n      flex: 0 0 auto;\n\n      &.is-open { color: var(--ghp-open); }\n      &.is-closed { color: var(--ghp-closed); }\n    }\n\n    .ghp-title-text {\n      color: var(--ghp-text);\n      font-weight: 500;\n      cursor: pointer;\n      overflow-wrap: anywhere;\n      word-break: break-word;\n      min-width: 400px;\n      max-width: 400px;\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n      text-overflow: ellipsis;\n\n      &:hover { color: var(--ghp-link); text-decoration: underline; }\n    }\n\n    .ghp-hashcode {\n      color: var(--ghp-text-muted);\n      font-size: 12px;\n      flex: 0 0 auto;\n    }\n  }\n\n  .ghp-pill {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    padding: 2px 10px;\n    border-radius: 2em;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 18px;\n    border: 1px solid transparent;\n    white-space: nowrap;\n    max-width: 100%;\n\n    &.is-lock {\n      padding-left: 6px;\n    }\n\n    .pill-dot {\n      width: 8px;\n      height: 8px;\n      border-radius: 50%;\n      display: inline-block;\n    }\n  }\n\n  .ghp-pill-cell {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    max-width: 100%;\n\n    .ghp-cell-caret {\n      color: var(--ghp-text-muted);\n      opacity: 0;\n      transition: opacity 0.1s;\n    }\n  }\n\n  tbody tr:hover .ghp-cell-caret { opacity: 1; }\n\n  .ghp-empty-cell {\n    color: var(--ghp-text-muted);\n    font-size: 12px;\n  }\n\n  .ghp-assignees {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n\n    .ant-avatar {\n      border: 2px solid var(--ghp-bg);\n    }\n\n    .ghp-assignee-name {\n      color: var(--ghp-text);\n      font-size: 13px;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      max-width: 120px;\n    }\n  }\n\n  .ghp-labels-cell {\n    display: inline-flex;\n    flex-wrap: wrap;\n    gap: 4px;\n    max-width: 260px;\n  }\n\n  &__footer {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    padding: 8px 12px;\n    border-top: 1px solid var(--ghp-border);\n    background: var(--ghp-bg);\n    color: var(--ghp-text-muted);\n    font-size: 12px;\n\n    .ant-pagination-item,\n    .ant-pagination-prev,\n    .ant-pagination-next,\n    .ant-pagination-jump-prev,\n    .ant-pagination-jump-next {\n      background: transparent;\n      border-color: var(--ghp-border);\n      a { color: var(--ghp-text); }\n    }\n\n    .ant-pagination-item-active {\n      background: var(--ghp-accent);\n      border-color: var(--ghp-accent);\n      a { color: #fff; }\n    }\n  }\n\n  &__empty {\n    padding: 56px 24px;\n    text-align: center;\n    color: var(--ghp-text-muted);\n  }\n\n  .ghp-title-edit {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    width: 100%;\n\n    input {\n      flex: 1;\n      padding: 4px 8px;\n      border: 1px solid var(--ghp-border);\n      border-radius: 4px;\n      font-size: 13px;\n      color: var(--ghp-text);\n      background: #fff;\n\n      &:focus {\n        outline: none;\n        border-color: var(--ghp-link);\n        box-shadow: 0 0 0 3px rgba(9,105,218,0.2);\n      }\n    }\n  }\n\n  .ghp-title-pencil {\n    opacity: 0;\n    cursor: pointer;\n    color: var(--ghp-text-muted);\n    padding: 2px 4px;\n    border-radius: 3px;\n    display: inline-flex;\n\n    &:hover { background: var(--ghp-surface-2); color: var(--ghp-text); }\n  }\n\n  tbody tr:hover .ghp-title-pencil { opacity: 1; }\n\n  .ghp-pill-cell {\n    cursor: pointer;\n  }\n\n  .ghp-date-cell {\n    cursor: pointer;\n\n    &:hover { color: var(--ghp-link); }\n  }\n}\n\n.ghp-autocomplete {\n  position: absolute;\n  top: 100%;\n  left: 12px;\n  right: 12px;\n  margin-top: 4px;\n  z-index: 20;\n  background: #fff;\n  border: 1px solid #d0d7de;\n  border-radius: 6px;\n  box-shadow: 0 8px 24px rgba(140, 149, 159, 0.2);\n  max-height: 280px;\n  overflow-y: auto;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif;\n\n  &__item {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 6px 12px;\n    cursor: pointer;\n    font-size: 13px;\n    color: #1f2328;\n    border-bottom: 1px solid #f6f8fa;\n\n    &:last-child { border-bottom: none; }\n    &:hover, &.is-active { background: #f6f8fa; }\n\n    .ghp-ac-kind {\n      font-size: 11px;\n      text-transform: uppercase;\n      color: #59636e;\n      background: #eaeef2;\n      border-radius: 3px;\n      padding: 1px 6px;\n      min-width: 56px;\n      text-align: center;\n    }\n\n    &.is-any .ghp-ac-kind { background: #ddf4ff; color: #0969da; }\n    &.is-no  .ghp-ac-kind { background: #fff8c5; color: #9a6700; }\n\n    .ghp-ac-label { flex: 1; }\n  }\n}\n\n.ghp-popover {\n  background: #ffffff;\n  border: 1px solid #d0d7de;\n  border-radius: 6px;\n  box-shadow: 0 8px 24px rgba(140, 149, 159, 0.2);\n  min-width: 260px;\n  max-width: 360px;\n  overflow: hidden;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif;\n\n  &__head {\n    padding: 8px 12px;\n    border-bottom: 1px solid #d8dee4;\n    font-size: 12px;\n    color: #59636e;\n    font-weight: 600;\n  }\n\n  &__search {\n    padding: 8px 12px;\n    border-bottom: 1px solid #d8dee4;\n\n    input {\n      width: 100%;\n      padding: 5px 8px;\n      border: 1px solid #d0d7de;\n      border-radius: 6px;\n      font-size: 13px;\n      background: #f6f8fa;\n\n      &:focus {\n        outline: none;\n        border-color: #0969da;\n        background: #fff;\n        box-shadow: 0 0 0 3px rgba(9,105,218,0.2);\n      }\n    }\n  }\n\n  &__list {\n    max-height: 280px;\n    overflow-y: auto;\n  }\n\n  &__item {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 6px 12px;\n    cursor: pointer;\n    font-size: 13px;\n    color: #1f2328;\n    border-bottom: 1px solid #f6f8fa;\n\n    &:hover { background: #f6f8fa; }\n    &.is-active { background: #ddf4ff; }\n    &:last-child { border-bottom: none; }\n\n    .ghp-check {\n      width: 16px;\n      flex: 0 0 auto;\n      color: #1f2328;\n      visibility: hidden;\n    }\n\n    &.is-selected .ghp-check { visibility: visible; }\n\n    .ghp-dot {\n      width: 10px;\n      height: 10px;\n      border-radius: 50%;\n      flex: 0 0 auto;\n    }\n\n    .ghp-item-label {\n      flex: 1;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n  }\n\n  &__empty {\n    padding: 16px;\n    text-align: center;\n    color: #59636e;\n    font-size: 12px;\n  }\n\n  &__foot {\n    padding: 6px 12px;\n    border-top: 1px solid #d8dee4;\n    background: #f6f8fa;\n    display: flex;\n    gap: 8px;\n    justify-content: space-between;\n\n    button {\n      padding: 2px 8px;\n      border: 1px solid #d0d7de;\n      background: #fff;\n      color: #1f2328;\n      border-radius: 4px;\n      cursor: pointer;\n      font-size: 12px;\n\n      &:hover { background: #f6f8fa; }\n      &.is-danger { color: #cf222e; }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
